import React from 'react'

const Footer = () => {
    return (
        <div>
            <div className='PreFooter'
                style={{
                    width: '100%',
                    //height: '100px',
                    backgroundColor: '#3e4f43'
                }}
            ></div>
            <div 
                className='Footer' 
                style={{
                    Width: '100%', 
                    height: '350px', 
                    backgroundColor: '#000000'
                }}
            >
            </div>
        </div>
    )
}

export default Footer